import { render, staticRenderFns } from "./RoomSpace.vue?vue&type=template&id=003492f8&"
import script from "./RoomSpace.vue?vue&type=script&lang=js&"
export * from "./RoomSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports